
import { Avatar, Button, Grid, Stack } from "@mui/material";
import { VisuallyHiddenInput } from "../../theme/originalTheme";
import { useImagenStore } from "../../stores";

const baseUrl = process.env.REACT_APP_API_URL;




export const AvatarScreen = ({ carpeta, bloqueo=false, contraste=false }) => {


    const { imagen, valorImagen } = useImagenStore();


    const handleFileChange = (e) => {
        valorImagen(e.target.files[0]);
    }
    


    return (

        <>
            <Grid item xs={12} sx={{display:'flex', justifyContent:'center', mb:4, mt:3}}>
                <Stack >
                    <Button sx={{width:200, height:200, borderRadius:'50%'}} component="label" 
                        onChange={ handleFileChange } disabled={bloqueo}
                    >
                    {imagen 
                    ?    <Avatar sx={{width:220, height:220, border:2, borderColor: 'primary.main'}}
                            className={contraste ? "img-blanco-negro" : ''} alt="Imagen Usuario"
                            src={(typeof imagen === 'string') 
                                ? `${baseUrl}/uploads/${carpeta}/${imagen}` 
                                : URL.createObjectURL(imagen)
                        }/>

                    :   <Avatar alt="Imagen Usuario" sx={{width:200, height:200}} />
                    }
                        <VisuallyHiddenInput type="file" />
                    </Button>
                </Stack>
            </Grid>
        </>
    )

}
